import { DashboardWidget } from './DashboardWidget';

interface Widget {
  id: string;
  reportId: string;
  reportName: string;
  chartType: 'bar' | 'line' | 'stacked' | 'table' | 'pie';
  gridX: number;
  gridY: number;
  gridW: number;
  gridH: number;
}

interface Props {
  widgets: Widget[];
  onRemove?: (id: string) => void;
}

// Simple CSS grid implementation. react-grid-layout can replace this once the
// drag-handle UX is needed; the saved gridX/Y/W/H values map directly.
export function DashboardGrid({ widgets, onRemove }: Props) {
  if (!widgets.length) {
    return (
      <div className="border border-dashed border-border rounded-lg p-10 text-center text-sm text-text-muted">
        No widgets yet. Save a report and add it to this dashboard.
      </div>
    );
  }

  return (
    <div className="grid grid-cols-12 auto-rows-[120px] gap-3">
      {widgets.map(w => (
        <div
          key={w.id}
          style={{
            gridColumn: `span ${Math.min(Math.max(w.gridW, 1), 12)}`,
            gridRow:    `span ${Math.max(w.gridH, 1)}`,
          }}
        >
          <DashboardWidget widget={w} onRemove={onRemove ? () => onRemove(w.id) : undefined} />
        </div>
      ))}
    </div>
  );
}
